import { render, staticRenderFns } from "./key-value-editor.vue?vue&type=template&id=5f8ff2ac&scoped=true&"
import script from "./key-value-editor.vue?vue&type=script&lang=ts&"
export * from "./key-value-editor.vue?vue&type=script&lang=ts&"
import style0 from "./key-value-editor.vue?vue&type=style&index=0&id=5f8ff2ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ff2ac",
  null
  
)

export default component.exports